import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { UtilityService } from './services/utility.service';
import { UserService } from './services/user.service';
import { DataService } from './services/data.service';
import { LoadingService } from './services/loading.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TicketService } from './services/ticket.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChatboxComponent } from './components/chatbox/chatbox.component';
// import {ConfirmationDialogComponent} from './components/chatbox/confirmation-dialog/confirmation-dialog.component';
import { MessageComponent } from './components/message/message.component';
import { ChatAuthInterceptor } from './interceptors/chat-auth.interceptor';
// import { QRCodeModule } from 'angularx-qrcode';
import { MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatStepperModule } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { LimitStatusDialogComponent } from './dialog/limit-status-dialog/limit-status-dialog.component';
import { TermsDialogComponent } from './dialog/terms-dialog/terms-dialog.component';
import { TicketTypeComponent } from './components/ticket-type/ticket-type.component';
import * as Sentry from "@sentry/angular-ivy";
import { Router } from '@angular/router';
import { ChangeLanguageComponent } from './dialog/change-language/change-language.component';
import { GlobalErrorHandler } from './global-error-handler';
// import { ServiceWorkerModule } from '@angular/service-worker';
// import { environment } from '../environments/environment';
// import { ImageCropperModule } from 'ngx-image-cropper';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        ChatboxComponent,
        MessageComponent,
        MessageDialogComponent,
        LimitStatusDialogComponent,
        ChangeLanguageComponent,
        // TicketTypeComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        // SocialLoginModule,
        MatFormFieldModule,
        MatIconModule,
        MatToolbarModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        MatRippleModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatBadgeModule,
        MatCardModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatNativeDateModule,
        // ImageCropperModule,
        NgxCaptchaModule,
        NgxMatSelectSearchModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        HttpClientModule,
        // QRCodeModule,
        MatStepperModule,
        // ServiceWorkerModule.register('ngsw-worker.js', {
        //   enabled: environment.production,
        //   // Register the ServiceWorker as soon as the app is stable
        //   // or after 30 seconds (whichever comes first).
        //   registrationStrategy: 'registerWhenStable:30000'
        // })
    ],
    providers: [
        UtilityService,
        UserService,
        DataService,
        LoadingService,
        TicketService,
        {
            useClass: ChatAuthInterceptor,
            provide: HTTP_INTERCEPTORS,
            multi: true,
        },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false }
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        }, {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
        {
          provide: ErrorHandler,
          useClass: GlobalErrorHandler
        }
        // {
        //   provide: 'SocialAuthServiceConfig',
        //   useValue: {
        //     autoLogin: false,
        //     providers: [
        //       {
        //         id: GoogleLoginProvider.PROVIDER_ID,
        //         provider: new GoogleLoginProvider(
        //           environment.GOOGLE_CLIENT_ID
        //         )
        //       },
        //       {
        //         id: FacebookLoginProvider.PROVIDER_ID,
        //         provider: new FacebookLoginProvider(environment.FACEBOOK_CLIENT_ID)
        //       }
        //     ]
        //   } as SocialAuthServiceConfig,s
        // }

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
